import type { SVGProps } from "react";

export const BugIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth={2}
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<path d="M12 20v-9" />
		<path d="M14 7a4 4 0 0 1 4 4v3a6 6 0 0 1-12 0v-3a4 4 0 0 1 4-4z" />
		<path d="M14.12 3.88 16 2" />
		<path d="M21 21a4 4 0 0 0-3.81-4" />
		<path d="M21 5a4 4 0 0 1-3.55 3.97" />
		<path d="M22 13h-4" />
		<path d="M3 21a4 4 0 0 1 3.81-4" />
		<path d="M3 5a4 4 0 0 0 3.55 3.97" />
		<path d="M6 13H2" />
		<path d="m8 2 1.88 1.88" />
		<path d="M9 7.13V6a3 3 0 1 1 6 0v1.13" />
	</svg>
);
